<template>
    <div class="base-form-div">
        <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="舰船型号" prop="type">
                <el-input placeholder="请输入舰船型号" v-model="ruleForm.type"></el-input>
            </el-form-item>
            <div class="form-bottom">
                <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">确定</el-button>
                <el-button class="base-button" size="mini" @click="resetForm('ruleForm')">重置</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import { createshipType ,updateshipType} from "@/api/shipType/index.js"
export default {
    props: ["subData"],
    data() {
        return {
            groupList: [],
            id: undefined,
            node: undefined,
            parentName: undefined,
            ruleForm: {
                type: "",
            },
            rules: {
                type: [
                    { required: true, message: "请输入舰船型号", trigger: "blur" }
                ],
            },
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.subData && this.subData.id) {
                        updateshipType(this.ruleForm).then(() => {
                            this.$message({
                                message: "编辑成功",
                                type: "success",
                            });
                            this.$bus.$emit("shipType-list");
                            this.$parent.close();
                        });
                        return;
                    }
                    createshipType(this.ruleForm).then(() => {
                        this.$message({
                            message: "添加成功",
                            type: "success",
                        });
                        this.$bus.$emit("shipType-list");
                        this.$parent.close();
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
    created() {
        if (this.subData && this.subData.id) {
            this.ruleForm = this.subData;
        }
    },
    mounted() { },
};
</script>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>